module.exports = __webpack_public_path__ + "img/bg.07a93716.png";